import intersectionBy from 'lodash/intersectionBy'

import { IRouteSetter, RoutePattern } from './__types'
import { CLEAN_SYMBOL } from './constants'
import { interpolateUrl } from './interpolateUrl'
import { getRoutingStore } from './routingStore'

let updateRouteTimeout: ReturnType<typeof setTimeout> | undefined

const paramsToUpdate: {
  params: any
  key: string
  value: string
  patterns?: RoutePattern[]
}[] = []

export const getUpdatedRoute = (params: typeof paramsToUpdate = paramsToUpdate) => {
  if (!params.length) return ''

  const _paramsToUpdate = params.map(it => it)
  params.length = 0

  const keysToUpdate = Object.fromEntries(_paramsToUpdate.map(it => [it.key]))

  const newParams = _paramsToUpdate.reduce((prev, curr) => {
    Object.entries(curr.params).forEach(([k, v]) => {
      if (prev[k] !== CLEAN_SYMBOL && !keysToUpdate.hasOwnProperty(k)) {
        prev[k] = v
      }
    })

    prev[curr.key] = curr.value

    return prev
  }, {} as any)

  const commonPatterns = (intersectionBy as any)(..._paramsToUpdate.map(it => it.patterns), 'pattern') as RoutePattern[]

  const newPattern =
    commonPatterns.find(it =>
      it.matches ? it.matches(getRoutingStore().location.pathname) : it.pattern === getRoutingStore().location.pathname,
    ) || commonPatterns[0]

  if (!commonPatterns.length) {
    throw new Error("Couldn't define a common route for the update")
  }

  return interpolateUrl(newPattern.pattern, newParams)
}

export const requestRouteUpdate = (
  setter: IRouteSetter,
  params: typeof paramsToUpdate extends Array<infer U> ? U : typeof paramsToUpdate,
) => {
  return new Promise<string>(resolve => {
    clearTimeout(updateRouteTimeout)

    paramsToUpdate.push(params)

    updateRouteTimeout = setTimeout(() => {
      const newRoute = getUpdatedRoute(paramsToUpdate)
      if (newRoute) setter(newRoute)
      resolve(newRoute)
    })
  })
}
